import * as phones from 'lang/phones.json';
import * as countries from 'lang/countries.json';

import {
  Input,
  OnInit,
  Component,
} from 'ng-metadata/core';

import phoneHtml from './phone.html';
import './phone.scss';

/**
 * Telephone Form Input Component
 *
 * Encapsulates behavior and template to enter
 * a valid phone number with country code.
 */
@Component({
  selector: 'gwFormPhone',
  template: phoneHtml,
})
export class FormPhoneComponent implements OnInit {
  public selected;
  public state: any = {
    phones,
    countries,
    types: {
      Home: {
        label: 'Home',
        value: 'landline',
        icon: 'landline',
      },
      Mobile: {
        label: 'Mobile',
        value: 'mobile',
        icon: 'mobile',
      },
      Office: {
        label: 'Office',
        value: 'landline',
        icon: 'office',
      },
      Other: {
        label: 'Other',
        value: 'landline',
        icon: 'other',
      },
    },
  };

  @Input() label;
  @Input() type;
  @Input() phone;
  @Input() country;
  @Input() hint: string;
  @Input() required: boolean;
  @Input() typeDisabled: boolean;

  ngOnInit() {
    this.selected = this.state.types[this.label];
  }

  updatePhone() {
    this.label = this.selected.label;
    this.type = this.selected.value;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/phone/phone.component.ts